export const setHiddenClassBody = () => document.querySelector(`body`).classList.add(`overflowHidden`);
